import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

// components
import Funcionarios from "./entities/Funcionarios";
import Motoristas from "./entities/Motoristas";
import Entregadores from "./entities/Entregadores";
import Administradores from "./entities/Administradores";
import Fretes from "./entities/Frete";

export default function CardFuncionario() {
  return (
    <div>
        
      <Tabs>
        <TabList className="flex justify-around mb-4">
      <div className="relative flex flex-col md:flex-row   min-w-0 break-words bg-white rounded mb-6 xl:mb-0 shadow-lg">
          <Tab className="p-4 cursor-pointer hover:bg-blue-200">Funcionários</Tab>
          <Tab className="p-4 cursor-pointer hover:bg-blue-200">Motoristas</Tab>
          <Tab className="p-4 cursor-pointer hover:bg-blue-200">Fretes</Tab>
          <Tab className="p-4 cursor-pointer hover:bg-blue-200">Entregadores</Tab>
          <Tab className="p-4 cursor-pointer hover:bg-blue-200">Administradores</Tab>
      </div>
        </TabList>

        <TabPanel>
          <Funcionarios />
        </TabPanel>
        <TabPanel>
          <Motoristas />
        </TabPanel>
        <TabPanel>
          <Fretes />
        </TabPanel>
        <TabPanel>
          <Entregadores />
        </TabPanel>
        <TabPanel>
          <Administradores />
        </TabPanel>
      </Tabs>
    </div>
  );
}
